import React from 'react';
import logo from './logo/immersia.png';
import useEasterTheme from './hooks/useEasterTheme';
import './SeasonalBanner.css';

const SeasonalBanner: React.FC = () => {
  const theme = useEasterTheme();

  if (!theme.isActive || !theme.mode) {
    return null;
  }

  return (
    <div className={`seasonal-banner seasonal-banner--${theme.mode}`}>
      <div className="seasonal-banner__glow seasonal-banner__glow--left" aria-hidden="true" />
      <div className="seasonal-banner__glow seasonal-banner__glow--right" aria-hidden="true" />

      <div className="seasonal-banner__content">
        <div className="seasonal-banner__brand">
          <img src={logo} alt="Immersia" className="seasonal-banner__logo" />
          <span className="seasonal-banner__eyebrow">{theme.bannerEyebrow}</span>
        </div>

        <div className="seasonal-banner__copy">
          <h2 className="seasonal-banner__title">{theme.bannerTitle}</h2>
          <p className="seasonal-banner__message">{theme.bannerMessage}</p>
        </div>

        {theme.mode === 'independence-day' ? (
          <div className="seasonal-banner__ornaments" aria-hidden="true">
            <span className="seasonal-banner__flag seasonal-banner__flag--one" />
            <span className="seasonal-banner__flag seasonal-banner__flag--two" />
            <span className="seasonal-banner__flag seasonal-banner__flag--three" />
          </div>
        ) : (
          <div className="seasonal-banner__ornaments" aria-hidden="true">
            <span className="seasonal-banner__egg seasonal-banner__egg--one" />
            <span className="seasonal-banner__egg seasonal-banner__egg--two" />
            <span className="seasonal-banner__egg seasonal-banner__egg--three" />
          </div>
        )}
      </div>

      {theme.mode === 'independence-day' && (
        <div className="seasonal-banner__confetti" aria-hidden="true">
          {Array.from({ length: 14 }).map((_, i) => (
            <span key={i} className="seasonal-banner__confetto" />
          ))}
        </div>
      )}
    </div>
  );
};

export default SeasonalBanner;
